import { useReduxState } from 'hooks';
import { getCustomizedNavTitle } from 'lib/helpers';
import { Page, PageContent, PageHeader, PageNav } from 'components/page';
import { FiltersProvider } from 'components/common/filter';

interface Props {
  activeLink: string;
  children: React.ReactNode;
}

const AnalyticsPage = ({ activeLink, children }: Props) => {
  const { language, messages, serverConfig, user } = useReduxState();

  const isDetailedPage = activeLink.includes('/analytics/detailed');
  const isSuperadmin = user?.roles.includes('superadmin');

  return (
    <Page activePathname="/analytics">
      <PageHeader
        icon="chart-line"
        title={getCustomizedNavTitle({
          defaultTitle: messages.commonAnalytics,
          navLinksCustomTexts: serverConfig.navLinksCustomTexts,
          language,
          section: 'analytics'
        })}
      />

      <PageNav
        activeLink={activeLink}
        links={[
          {
            href: '/analytics',
            icon: 'chart-bar',
            title: messages.commonActivity
          },
          {
            href: '/analytics/detailed',
            icon: 'chart-line',
            title: messages.analyticsDetailedAnalytics
          },
          ...(serverConfig.platformCompetenciesOnly
            ? []
            : [
                {
                  href: '/analytics/completions',
                  icon: 'history' as const,
                  title: messages.profileCompletionHistory
                },
                {
                  href: '/analytics/completion-matrix',
                  icon: 'table' as const,
                  title: messages.completionMatrix
                }
              ]),
          ...(isSuperadmin
            ? [
                {
                  href: '/analytics/superadmin',
                  icon: 'tasks' as const,
                  title: messages.usersSuperadmin
                }
              ]
            : [])
        ]}
      />

      <FiltersProvider
        filters={{
          groups: true,
          supervisors:
            user?.roles.includes('superadmin') ||
            user?.roles.includes('supervisor'),
          userAttributes: true,
          ...(isDetailedPage && {
            achievements: true,
            calendarEvents: true,
            competences: true,
            competenceProfiles: true,
            courses: true,
            paths: true
          })
        }}
        savedFiltersAllowed={true}
      >
        <PageContent>{children}</PageContent>
      </FiltersProvider>
    </Page>
  );
};

export default AnalyticsPage;
